module.exports = __webpack_public_path__ + "static/media/Bank.19f788ef.svg";